import { clearAuthFlags, submitRegisterRequest } from 'actions/authentication';
import FormAuthTextField from 'components/FormElements/FormAuthTextField';
import FormSubmitButton from 'components/FormElements/FormSubmitButton';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { Required } from 'utils/validators';
import './index.scss';

class RegisterForm extends Component {
  componentWillMount() {
    this.props.handleSubmit(() => ({}));
    this.props.clearAuthFlags();
  }

  submitRegister = () => {
    const { firstName, lastName, email, pwd } = this.props.formValues;

    this.props.submitRegisterRequest(firstName, lastName, email, pwd);
  };

  onEnter = event => {
    if (event.key === 'Enter') {
      this.submitRegister();
    }
  };

  getSubmissionError(formField, errorField) {
    const value = this.props.formValues[formField];

    const validationField = errorField || formField;
    const error = this.props.registerError;
    const vError =
      error.validationErrors && error.validationErrors[validationField];

    if (vError && vError.value === value) {
      return vError.title;
    }
  }

  render() {
    return (
      <React.Fragment>
        <h3>Register with Fatsoma</h3>

        {this.props.registerError.detail && (
          <div className="auth__error">{this.props.registerError.detail}</div>
        )}
        <form className="auth__form__fields" onKeyDown={this.onEnter}>
          <input type="hidden" value="prayer" />
          <Field
            className="auth__form__field"
            fullWidth
            autoComplete="given-name"
            name="firstName"
            type="text"
            margin="normal"
            placeholder="John"
            component={FormAuthTextField}
            validate={[Required]}
            submissionError={this.getSubmissionError('firstName')}
            label="First Name"
          />

          <Field
            className="auth__form__field"
            fullWidth
            autoComplete="family-name"
            name="lastName"
            type="text"
            margin="normal"
            placeholder="Smith"
            component={FormAuthTextField}
            validate={[Required]}
            submissionError={this.getSubmissionError('lastName')}
            label="Last Name"
          />

          <Field
            className="auth__form__field"
            fullWidth
            autoComplete="email"
            name="email"
            type="email"
            margin="normal"
            placeholder="john.smith@me.com"
            component={FormAuthTextField}
            validate={[Required]}
            submissionError={this.getSubmissionError('email')}
            label="Email Address"
          />

          <Field
            className="auth__form__field"
            fullWidth
            autoComplete="new-password"
            name="pwd"
            type="password"
            margin="normal"
            placeholder="password"
            component={FormAuthTextField}
            validate={[Required]}
            submissionError={this.getSubmissionError('pwd', 'password')}
            label="Password"
          />

          <FormSubmitButton
            onClick={this.submitRegister}
            className="auth__cta__button"
            loading={this.props.loading}
          >
            Register
          </FormSubmitButton>
        </form>

        <div className="auth__line__break" />

        <div className="already__registered">
          <div className="already__registered__header">
            Already have a Fatsoma account?
          </div>
          <div className="already__registered__cta">
            <Link to="./login" className="login__link">
              Sign In
            </Link>
          </div>
        </div>

        <div className="auth__line__break" />

        <div className="register__terms">
          <div>By signing up you agree to Fatsoma's</div>
          <a
            href="https://www.fatsoma.com/policies"
            rel="noopener noreferrer"
            target="_blank"
          >
            Terms & Conditions
          </a>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues('register')(state) || {},
    loading: state.authentication.loading,
    registerError: state.authentication.registerError,
    initialValues: state.authentication.formData['register'],
  };
};

const mapDispatchToProps = dispatch => ({
  submitRegisterRequest: (firstName, lastName, email, pwd) =>
    dispatch(submitRegisterRequest(firstName, lastName, email, pwd)),
  clearAuthFlags: () => dispatch(clearAuthFlags()),
});

RegisterForm = reduxForm({
  form: 'register',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(RegisterForm);

export default connect(mapStateToProps, mapDispatchToProps)(RegisterForm);



// WEBPACK FOOTER //
// ./src/components/Authentication/RegisterForm/index.jsx